import { createIcon } from "@chakra-ui/icons";

export const RowCollapseIcon = createIcon({
  displayName: "RowCollapseIcon",
  viewBox: "0 0 20 20",
  defaultProps: {
    width: "20px",
    height: "20px",
  },
  path: (
    <path
      d="M10 18.3334V14.1667M10 14.1667L7.5 16.25M10 14.1667L12.5 16.25M10 1.66669V5.83335M10 5.83335L7.5 3.75002M10 5.83335L12.5 3.75002M2.5 10C2.5 9.48231 2.5 9.22345 2.62877 9.01926C2.80045 8.74701 3.12977 8.5307 3.54426 8.41793C3.85512 8.33335 4.24922 8.33335 5.03741 8.33335L11.8038 8.33335C12.592 8.33335 16.1449 8.33335 16.4557 8.41793C16.8702 8.5307 17.1995 8.74701 17.3712 9.01926C17.5 9.22345 17.5 9.48231 17.5 10C17.5 10.5177 17.5 10.7766 17.3712 10.9808C17.1995 11.253 16.8702 11.4693 16.4557 11.5821C16.1449 11.6667 12.592 11.6667 11.8038 11.6667H5.03741C4.24922 11.6667 3.85512 11.6667 3.54426 11.5821C3.12977 11.4693 2.80045 11.253 2.62877 10.9808C2.5 10.7766 2.5 10.5177 2.5 10Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
});
